var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDfi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF00AF",
    d: "M13.717 17.112V6.887c2.2.658 3.429 2.7 3.429 5.112s-1.228 4.454-3.43 5.111M11.997 5.14v5.78l-.87-.87l-.112-2.173l.908-2.732a6.8 6.8 0 0 0-1.683.232l-.44 1.32l-1.245-.624c-.493.287-.948.63-1.353 1.027l2.306 1.155l.068 1.322l-1.323-.067l-1.156-2.306A7 7 0 0 0 6.07 8.557l.625 1.245l-1.322.44a6.8 6.8 0 0 0-.231 1.682l2.733-.908l2.173.111l.871.871l-.87.87l-2.174.112l-2.733-.908a7 7 0 0 0 .231 1.683l1.322.438l-.625 1.245c.285.492.63.947 1.027 1.354l1.156-2.306l1.323-.067l-.068 1.321l-2.306 1.156c.407.397.861.742 1.353 1.027l1.246-.625l.439 1.321a7 7 0 0 0 1.683.232l-.908-2.732l.111-2.173l.871-.87v5.78A6.86 6.86 0 0 0 18.857 12a6.86 6.86 0 0 0-6.859-6.857"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDfi);
export default __webpack_public_path__ + "static/media/dfi.e6728cd10b66f963f1270236cacf9809.svg";
export { ForwardRef as ReactComponent };